module.exports = __webpack_public_path__ + "./images/doc.bb1d87.jpg";